import axios from 'axios';
import config from './config';

class home {
    constructor() {
        this.url = config.url();
    }

    async list(){
        try{
            var data = { };
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/home/list",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async search(term){
        try{
            var data = { search:term };
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/home/search",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async list_customers(){
        try{
            var data = { };
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/home/list/customers",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async list_products(){
        try{
            var data = { };
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/home/list/products",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async list_sales(){
        try{
            var data = { };
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/home/list/sales",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async list_invoices(){
        try{
            var data = { };
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/home/list/invoices",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }
}

export default new home()